import React from "react";
import { SvgIcon } from "@mui/material";

// TODO make the names of the SVG consistent, no space, all lower case, and camelcase
import AuditLogsSVG from "./icons/Activity Log.svg";
import DownloadIconSVG from "./icons/download filled.svg";
import DownloadOutlineIconSVG from "./icons/download_outline.svg";
import PrintIconSVG from "./icons/print filled.svg";
import SearchIconSVG from "./icons/search.svg";
import ViewColumnIconSVG from "./icons/compare filled.svg";
import FilterIconSVG from "./icons/slider filled.svg";
import UploadIconSVG from "./icons/upload filled.svg";
import MenuIconSVG from "./icons/menu.svg";
import AccountIconSVG from "./icons/user filled.svg";
import WorldIconSVG from "./icons/world outline.svg";
import BuildingIconSVG from "./icons/bankAccountDefault.svg";
import PendingRequestDefaultSVG from "./icons/pendingRequestDefault.svg";
import BuildingOutlineIconSVG from "./icons/building outline.svg";
import CurrencyIconSVG from "./icons/currency filled.svg";
import UserIconSVG from "./icons/user outline.svg";
import VoiceIconSVG from "./icons/voice input outline.svg";
import SurveyIconSVG from "./icons/surveyDefault.svg";
import ChatIconSVG from "./icons/chatDefault.svg";
import HelpIconSVG from "./icons/supportDefault.svg";
import FolderIconSVG from "./icons/libraryDefault.svg";
import MyPageIconSVG from "./icons/myPage outline.svg";
import CreditCardIconSVG from "./icons/credit card filled.svg";
import InfoIconSVG from "./icons/info filled.svg";
import InfoOutlineIconSVG from "./icons/info outline.svg";
import ShopIconSVG from "./icons/shop filled.svg";
import PriceYenIconSVG from "./icons/GlobalRatesDefault.svg";
import SecurityIconSVG from "./icons/security filled.svg";
import PDFIconSVG from "./icons/pdf_filled.svg";
import PDFOutlineIconSVG from "./icons/pdf_outline.svg";
import ListIconSVG from "./icons/list filled.svg";
import ListOutlineIconSVG from "./icons/list_outline.svg";
import DashboardIconSVG from "./icons/dashboardDefault.svg";
import EnterpriseIconSVG from "./icons/enterpriseListDefault.svg";
import AnalyticsIconSVG from "./icons/analyticsDefault.svg";
import UserManagementIconSVG from "./icons/userManagementDefault.svg";
import UserGearIconSVG from "./icons/userGearDefault.svg";
import AdminUserSVG from "./icons/admin users.svg";
import InvoicesSVG from "./icons/invoicesDefault.svg";
import HistoricInvoiceSVG from "./icons/historicInvoiceDefault.svg";
import CostIconSVG from "./icons/costDefault.svg";
import QualitySVG from "./icons/qualityDefault.svg";
import DLRSVG from "./icons/dlr.svg";
import SendSMSIconSVG from "./icons/sendSmsDefault.svg";
import SMSGuideIconSVG from "./icons/sms_guide.svg";
import InboxMessageDefaultSVG from "./icons/inboxMessageDefault.svg";
import CampaignSVG from "./icons/campaignDefault.svg";
import SendDeliveryIconSVG from "./icons/Send Deliver.svg";
import AddEnterpriseIconSVG from "./icons/AddEnterprise.svg";
import EnterpriseFilterIconSVG from "./icons/EnterpriseFilter.svg";
import ColumnsIconSVG from "./icons/ColumnsModal.svg";
import SuspendRowIconSVG from "./icons/SuspendRow.svg";
import EditRowIconSVG from "./icons/EditRow.svg";
import DeleteRowIconSVG from "./icons/DeleteRow.svg";
import OutboundCostIconSVG from "./icons/outBoundCostDefault.svg";
import OutboundPriceIconSVG from "./icons/OutBoundPriceRuleDefault.svg";
import ResellerIconSVG from "./icons/resellerDefault.svg";
import UserGroupIconSVG from "./icons/userDefault.svg";
import RightChevronIconDefaultSVG from "./icons/rightChevronDefault.svg";
import LeftChevronIconDefaultSVG from "./icons/leftChevronDefault.svg";
import DotsIconSvg from "./icons/Vertical Dots.svg";
import CalendarIconSVG from "./icons/calendar outline.svg";
import ColumnUnfrozenIconSVG from "./icons/Column Unfrozen.svg";
import CloseIconSVG from "./icons/close button.svg";
import MarkAsReadSVG from "./icons/Mark as read.svg";
import CheckIconSVG from "./icons/check.svg";
import TotalSuccessIconSVG from "./icons/Total_success.svg";
import TotalCostIconSvg from "./icons/totalcost.svg";
import TotalMarginIconSvg from "./icons/totalmargin.svg";
import TotalRevenueIconSvg from "./icons/totalrevenue.svg";
import TotalVolumeIconSvg from "./icons/totalvolume.svg";
import ExpandIconSvg from "./icons/expand.svg";
import CollapseIconSvg from "./icons/collapse.svg";
import RefreshButtonIcon from "./icons/refresh.svg";
import ReloadButtonIcon from "./icons/reload.svg";
import ErrorTriangleIcon from "./icons/error_triangle.svg";
import CrossIcon from "./icons/crossIcon.svg";
import HideLimitIcon from "./icons/crossLimitIcon.svg";
import DefaultMenuIcon from "./icons/menu_default.svg";
import CheckBoxCheckIcon from "./icons/checkBoxIconCheck.svg";
import CheckBoxUnCheckIcon from "./icons/checkBoxUnCheck.svg";
import SystemMessageIcon from "./icons/audienceMessageIcon.svg";
import ShowModalIcon from "./icons/showModalIcon.svg";
import HideModalIcon from "./icons/hideModalIcon.svg";
import HeavyCheckIcon from "./icons/green_check_icon.svg";
import EyeOpenIcon from "./icons/eyeOpen.svg";
import EyeCloseIcon from "./icons/eyeClose.svg";
import Notification from "./icons/notice generic outline.svg";
import DownArrow from "./icons/chevron down.svg";
import DownArrowFilled from "./icons/arrowDownFilled.svg";
import UpArrowFilled from "./icons/arrowUpFilled.svg";
import UpArrow from "./icons/chevron up.svg";
import Configuration from "./icons/configuration.svg";
import Setting from "./icons/settings outline.svg";
import ResetIconSvg from "./icons/reset.svg";
import ResetModalIconSvg from "./icons/resetModalIcon.svg";
import GeneralIconSvg from "./icons/General Icon.svg";
import TickSvg from "./icons/tick.svg";
import AddTemplateSvg from "./icons/add template.svg";
import StatusCloseSvg from "./icons/Close.svg";
import StatusPendingSvg from "./icons/Pending.svg";
import StatusRetiredSvg from "./icons/Retired.svg";
import PlusIconSvg from "./icons/plus.svg";
import MinusIconSvg from "./icons/minus.svg";
import LinkIconSvg from "./icons/link.svg";
import RMI_LOGO_ICON from "./icons/RMI_logo_dark.svg";
import CheckCircleSvg from "./icons/checkCircle.svg";
import UploadOutlineSvg from "./icons/uploadOutline.svg";
import CsvDownloadBtn from "./icons/csv_download_btn.svg";
import RakutenSymphonyImg from "./icons/RakutenSymphonyLogo.svg";
import CsvIcon from "./icons/Csv_icon.svg";
import DlrLookupSvg from "./icons/dlrlookup.svg";
import FaqSVG from "./icons/faq.svg";
import CopyField from "./icons/copyField.svg";
import Insight from "./icons/Insight.svg";
import Outline from "./icons/outline.svg";
import RAKUTEN_LOGO from "./icons/Rakuten_logo.svg";
import UserIconSvg from "./icons/user.svg";
import InvitationIconSvg from "./icons/invite.svg";
import DataNotAvailable from "./icons/dataNotAvailable.svg";
import TableOptionsSvg from "./icons/tableOptions.svg";
import CsvRedSvg from "./icons/csv.svg";
import WarningOutlinedSvg from "./icons/warning outlined.svg";
import DummyStatusIcon from "./icons/DummyStatusIcon.svg";
import Logout from "./icons/logout.svg";
import LogoutImage from "./icons/logoutImage.svg";
import GreyCsvDownloadBtn from "./icons/csv_download_grey.svg";
import ConfirmIconImage from "./icons/confirmIcon.svg";
import DeleteImage from "./icons/deleteIcon.svg";
import NotFoundImage from "./icons/not-found-image.svg";
import NewVersion from "./icons/Infographics New Version.svg";
import TokenExpired from "./icons/Infographics Confirmation.svg";
import ChangeTemplate from "./icons/ChangeTemplate.svg";
import SearchResultNotFound from "./icons/searchResultNotFound.svg";
import ArrowPointingLeft from "./icons/arrow left.svg";
import SuccessSVG from "./icons/success.svg";
import AlertSVG from "./icons/alert.svg";
import InfoSVG from "./icons/info.svg";
import RightArrowSVG from "./icons/arrow right grey.svg";
import CloseModalSVG from "./icons/closeModal.svg";
import UserDeleteSVG from "./icons/userDelete.svg";
import UserCheckSVG from "./icons/userCheck.svg";
import TerminateSVG from "./icons/terminate.svg";
import TerminateLargeSVG from "./icons/terminateLarge.svg";
import TickCircleSVG from "./icons/tickCircle.svg";
import CrossCircleSVG from "./icons/crossCircle.svg";
import ResumeModalSVG from "./icons/Infographics Confirmation Resume.svg";
import PauseModalSVG from "./icons/Infographics Confirmation Pause.svg";
import PauseIconSVG from "./icons/PauseIcon.svg";
import ResumeIconSVG from "./icons/ResumeIcon.svg";
import CrownIconSVG from "./icons/crown.svg";
import SenderIdManagementIconSVG from "./icons/senderIdManagement.svg";
import ServiceManagementIconSVG from "./icons/ServiceManagement.svg";
import TimeIconSVG from "./icons/time.svg";
import TableIconSvg from "./icons/table.svg";
import UserTagSVG from "./icons/UserTagIcon.svg";
import ResellerTagSVG from "./icons/ResellerTagIcon.svg";
import AdminTagSVG from "./icons/AdminTagIcon.svg";
import SuperAdminTagSVG from "./icons/super_admin_user.svg";
import ItemizationReportSVG from "./icons/itemizationReport.svg";
import ItemizationReportDownloadSVG from "./icons/itemizationReport_download_icon.svg";
import TransactionReportSMSIcon from "./icons/transactionReport.svg";
import MOTransactionReportSMSIcon from "./icons/motransactionReport.svg";
import SupportIconSVG from "./icons/support.svg";
import ManagementIconSVG from "./icons/propertyManagement.svg";
import DistributionIconSVG from "./icons/distribution.svg";
import ReportsSVG from "./icons/reports.svg";
import ContactUsIconSVG from "./icons/contactUs.svg";
import DeLinkSVG from "./icons/delink.svg";
import EditTemplateIconSVG from "./icons/edit_template.svg";
import SaveTemplateIconSVG from "./icons/save.svg";
import NoTemplateFoundSVG from "./icons/no_template.svg";
import EnterpriseConfigIconSVG from "./icons/enterpriseConfigIcon.svg";
import ConfirmAPIIconSVG from "./icons/confirmApiIconUpdated.svg";
import ConfirmAPIDashboardIconSVG from "./icons/confirmAPIDashboardIcon.svg";
import DownloadInfoIconSVG from "./icons/infographicsDownload.svg";
import SmsServiceIconSVG from "./icons/SmsService.svg";
import EnterpriseListIconSVG from "./icons/enterpriseList.svg";
import PendingRequestIconSVG from "./icons/pendingRequest.svg";
import SenderIdIconSVG from "./icons/senderId.svg";
import AdminUserIconSVG from "./icons/adminUsers.svg";
import AuditLogsIconSVG from "./icons/auditLogs.svg";
import CampaignTransationIconSVG from "./icons/campaignTransaction.svg";
import EnterpriseUserIconSVG from "./icons/enterpriseUser.svg";
import ItemizationReportsIconSVG from "./icons/itemizationReports.svg";
import ResellersIconSVG from "./icons/reseller.svg";
import HomeIconSVG from "./icons/home outline.svg";
import GlobalRoutingRulesSvg from "./icons/globalRoutingRules.svg";
import ConfirmApiHomeIconSVG from "./icons/ConfirmApiHomeIcon.svg";
import ConfirmAPITransactionIconSVG from "./icons/confirmAPITransactionIcon.svg";
import CancellationModalSVG from "./icons/InfographicsCancellation.svg";
import CsvViewSVG from "./icons/csvViewIcon.svg";
import DoubleCheckSVG from "./icons/doubleCheckIcon.svg";
import SpamControlIconSVG from "./icons/spamControl.svg";
import Infographic from "./icons/Infographic.svg";
import AdminUsersTag from "./icons/admin_users_tag.svg";
import ResellerUsersTag from "./icons/reseller_users_tag.svg";
import InProgress from "./icons/inProgress.svg";
import Download from "./icons/Download.svg";
import MailIconSVG from "./icons/mail outline.svg";
import ExecutionConfirmation from "./icons/executionConfirmation.svg";
import InfographicsConfirmation from "./icons/InfographicsConfirmation.svg";
import ExecuteIconSVG from "./icons/execute.svg";
import OnboardingIconSVG from "./icons/onboarding.svg";
import MessageApiIconSVG from "./icons/messageApi.svg";
import MessageConfirmationIconSVG from "./icons/message_confirmation.svg";
import MessagingToolIconSVG from "./icons/messaging_tools.svg";
import PhoneOutlineIconSVG from "./icons/phone outline.svg";
import DragDropIconSVG from "./icons/drag_drop.svg";
import CheckBoxDisable from "./icons/CheckboxDisable.svg";
import SaveModalIconSVG from "./icons/saveModalIcon.svg";

const UserTagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserTagSVG />
    </SvgIcon>
  );
};

const ResellerTagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ResellerTagSVG />
    </SvgIcon>
  );
};

const AdminTagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AdminTagSVG />
    </SvgIcon>
  );
};

const SuperAdminTagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SuperAdminTagSVG />
    </SvgIcon>
  );
};

const AdminUsersTagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AdminUsersTag />
    </SvgIcon>
  );
};

const ResellerUsersTagIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ResellerUsersTag />
    </SvgIcon>
  );
};

const MailIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MailIconSVG />
    </SvgIcon>
  );
};

const CrownIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CrownIconSVG />
    </SvgIcon>
  );
};

const PauseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PauseIconSVG />
    </SvgIcon>
  );
};

const ResumeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ResumeIconSVG />
    </SvgIcon>
  );
};

const PauseModalImage = (props) => {
  return (
    <SvgIcon {...props}>
      <PauseModalSVG />
    </SvgIcon>
  );
};

const ResumeModalImage = (props) => {
  return (
    <SvgIcon {...props}>
      <ResumeModalSVG />
    </SvgIcon>
  );
};

const AuditLogsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AuditLogsSVG />
    </SvgIcon>
  );
};

const CloseModalImage = (props) => {
  return (
    <SvgIcon {...props}>
      <CloseModalSVG />
    </SvgIcon>
  );
};

const UserImageIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserIconSvg />
    </SvgIcon>
  );
};

const SuccessIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SuccessSVG />
    </SvgIcon>
  );
};

const AlertIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AlertSVG />
    </SvgIcon>
  );
};

const EventInfoIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InfoSVG />
    </SvgIcon>
  );
};

const RightArrowGreyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <RightArrowSVG />
    </SvgIcon>
  );
};

const DummyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DummyStatusIcon />
    </SvgIcon>
  );
};
const InvitationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InvitationIconSvg />
    </SvgIcon>
  );
};

const InsightIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Insight />
    </SvgIcon>
  );
};

const OutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Outline />
    </SvgIcon>
  );
};

const CopyFieldIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CopyField />
    </SvgIcon>
  );
};

const FaqIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <FaqSVG />
    </SvgIcon>
  );
};

const EyeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EyeOpenIcon />
    </SvgIcon>
  );
};

const CSVIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CsvIcon />
    </SvgIcon>
  );
};

const CsvDownloadButton = (props) => {
  return (
    <SvgIcon {...props}>
      <CsvDownloadBtn />
    </SvgIcon>
  );
};

const GreyCsvDownloadButton = (props) => {
  return (
    <SvgIcon {...props}>
      <GreyCsvDownloadBtn />
    </SvgIcon>
  );
};

const UploadCsvIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UploadOutlineSvg />
    </SvgIcon>
  );
};

const RMI_LOGO = (props) => {
  return (
    <SvgIcon {...props}>
      <RMI_LOGO_ICON />
    </SvgIcon>
  );
};

const RakutenSymphonyLogo = (props) => {
  return (
    <SvgIcon {...props}>
      <RakutenSymphonyImg />
    </SvgIcon>
  );
};

const ResetIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ResetIconSvg />
    </SvgIcon>
  );
};
const ResetModalIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ResetModalIconSvg />
    </SvgIcon>
  );
};

const GeneralIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <GeneralIconSvg />
    </SvgIcon>
  );
};

const EyeBanIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EyeCloseIcon />
    </SvgIcon>
  );
};

const SmsGuideIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SMSGuideIconSVG />
    </SvgIcon>
  );
};

const GreenCheckIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <HeavyCheckIcon />
    </SvgIcon>
  );
};

const DLRIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DLRSVG />
    </SvgIcon>
  );
};

const ErrorTriangleOutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ErrorTriangleIcon />
    </SvgIcon>
  );
};

const ShownModalDownIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ShowModalIcon />
    </SvgIcon>
  );
};

const HideModalUpIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <HideModalIcon />
    </SvgIcon>
  );
};

const SystemAudienceMessageIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SystemMessageIcon />
    </SvgIcon>
  );
};

const UnCheckBoxIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CheckBoxUnCheckIcon />
    </SvgIcon>
  );
};

const CheckBoxIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CheckBoxCheckIcon />
    </SvgIcon>
  );
};

const MenuDefaultIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DefaultMenuIcon />
    </SvgIcon>
  );
};

const PendingRequestIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PendingRequestDefaultSVG />
    </SvgIcon>
  );
};

const SpamControlIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SpamControlIconSVG />
    </SvgIcon>
  );
};

const CrossLimitIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <HideLimitIcon />
    </SvgIcon>
  );
};

const CrossShowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CrossIcon />
    </SvgIcon>
  );
};

const RefreshIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <RefreshButtonIcon />
    </SvgIcon>
  );
};

const ReloadIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ReloadButtonIcon />
    </SvgIcon>
  );
};

const ExpandIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ExpandIconSvg />
    </SvgIcon>
  );
};

const CollapseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CollapseIconSvg />
    </SvgIcon>
  );
};

const TickIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TickSvg />
    </SvgIcon>
  );
};

const TotalCostIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TotalCostIconSvg />
    </SvgIcon>
  );
};

const TotalMarginIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TotalMarginIconSvg />
    </SvgIcon>
  );
};
const TotalRevenueIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TotalRevenueIconSvg />
    </SvgIcon>
  );
};

const DownloadOutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DownloadOutlineIconSVG />
    </SvgIcon>
  );
};
const PDFOutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PDFOutlineIconSVG />
    </SvgIcon>
  );
};
const InboxMessageDefaultIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InboxMessageDefaultSVG />
    </SvgIcon>
  );
};

const ListOutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ListOutlineIconSVG />
    </SvgIcon>
  );
};

const TotalVolumeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TotalVolumeIconSvg />
    </SvgIcon>
  );
};

const TotalSuccessIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TotalSuccessIconSVG />
    </SvgIcon>
  );
};

const ColumnUnfrozenIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ColumnUnfrozenIconSVG />
    </SvgIcon>
  );
};

const CalendarIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CalendarIconSVG />
    </SvgIcon>
  );
};

const CloseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CloseIconSVG />
    </SvgIcon>
  );
};

const MarkAsRead = (props) => {
  return (
    <SvgIcon {...props}>
      <MarkAsReadSVG />
    </SvgIcon>
  );
};

const StatusCloseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <StatusCloseSvg />
    </SvgIcon>
  );
};

const StatusPendingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <StatusPendingSvg />
    </SvgIcon>
  );
};

const StatusRetiredIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <StatusRetiredSvg />
    </SvgIcon>
  );
};

const CsvViewIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CsvViewSVG />
    </SvgIcon>
  );
};

const CheckIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CheckIconSVG />
    </SvgIcon>
  );
};

const DoubleCheckIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DoubleCheckSVG />
    </SvgIcon>
  );
};

const UserGroupIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserGroupIconSVG />
    </SvgIcon>
  );
};

const ResellerIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ResellerIconSVG />
    </SvgIcon>
  );
};

const DotsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DotsIconSvg />
    </SvgIcon>
  );
};
const OutboundPriceIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <OutboundPriceIconSVG />
    </SvgIcon>
  );
};

const OutboundCostIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <OutboundCostIconSVG />
    </SvgIcon>
  );
};

const SuspendRowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SuspendRowIconSVG />
    </SvgIcon>
  );
};
const EditRowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EditRowIconSVG />
    </SvgIcon>
  );
};
const DeleteRowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DeleteRowIconSVG />
    </SvgIcon>
  );
};
const ColumnsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ColumnsIconSVG />
    </SvgIcon>
  );
};
const EnterpriseFilterIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EnterpriseFilterIconSVG />
    </SvgIcon>
  );
};

const AddEnterpriseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AddEnterpriseIconSVG />
    </SvgIcon>
  );
};

const EnterpriseConfigIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EnterpriseConfigIconSVG />
    </SvgIcon>
  );
};

const ConfirmAPIIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ConfirmAPIIconSVG />
    </SvgIcon>
  );
};

const ConfirmAPIDashboardIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ConfirmAPIDashboardIconSVG />
    </SvgIcon>
  );
};

const ConfirmAPITransactionIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ConfirmAPITransactionIconSVG />
    </SvgIcon>
  );
};

const UserManagementIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserManagementIconSVG />
    </SvgIcon>
  );
};

const UserGearIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserGearIconSVG />
    </SvgIcon>
  );
};

const AnalyticsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AnalyticsIconSVG />
    </SvgIcon>
  );
};

const EnterpriseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EnterpriseIconSVG />
    </SvgIcon>
  );
};

const DashboardIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DashboardIconSVG />
    </SvgIcon>
  );
};

const DownloadIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DownloadIconSVG />
    </SvgIcon>
  );
};
const PrintIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PrintIconSVG />
    </SvgIcon>
  );
};
const SearchIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SearchIconSVG />
    </SvgIcon>
  );
};
const ViewColumnIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ViewColumnIconSVG />
    </SvgIcon>
  );
};
const FilterIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <FilterIconSVG />
    </SvgIcon>
  );
};
const UploadIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UploadIconSVG />
    </SvgIcon>
  );
};
const MenuIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MenuIconSVG />
    </SvgIcon>
  );
};
const AccountIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AccountIconSVG />
    </SvgIcon>
  );
};
const WorldIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <WorldIconSVG />
    </SvgIcon>
  );
};
const BuildingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <BuildingIconSVG />
    </SvgIcon>
  );
};

const BuildingOutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <BuildingOutlineIconSVG />
    </SvgIcon>
  );
};
const CurrencyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CurrencyIconSVG />
    </SvgIcon>
  );
};
const UserIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserIconSVG />
    </SvgIcon>
  );
};
const VoiceIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <VoiceIconSVG />
    </SvgIcon>
  );
};
const SurveyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SurveyIconSVG />
    </SvgIcon>
  );
};

const ChatIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ChatIconSVG />
    </SvgIcon>
  );
};

const HelpIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <HelpIconSVG />
    </SvgIcon>
  );
};

const FolderIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <FolderIconSVG />
    </SvgIcon>
  );
};

const MyPageIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MyPageIconSVG />
    </SvgIcon>
  );
};
const CreditCardIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CreditCardIconSVG />
    </SvgIcon>
  );
};
const InfoIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InfoIconSVG />
    </SvgIcon>
  );
};
const InfoOutlineIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InfoOutlineIconSVG />
    </SvgIcon>
  );
};
const ShopIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ShopIconSVG />
    </SvgIcon>
  );
};
const PriceYenIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PriceYenIconSVG />
    </SvgIcon>
  );
};

const SecurityIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SecurityIconSVG />
    </SvgIcon>
  );
};
const PDFIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PDFIconSVG />
    </SvgIcon>
  );
};
const ListIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ListIconSVG />
    </SvgIcon>
  );
};
const AdminUserIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <AdminUserSVG />
    </SvgIcon>
  );
};
const InvoicesIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InvoicesSVG />
    </SvgIcon>
  );
};

const DownloadInfoIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DownloadInfoIconSVG />
    </SvgIcon>
  );
};

const HistoricInvoicesIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <HistoricInvoiceSVG />
    </SvgIcon>
  );
};

const CostIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CostIconSVG />
    </SvgIcon>
  );
};

const QualityIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <QualitySVG />
    </SvgIcon>
  );
};

const SendSMSIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SendSMSIconSVG />
    </SvgIcon>
  );
};

const CampaignIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CampaignSVG />
    </SvgIcon>
  );
};

const SendDeliveryIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SendDeliveryIconSVG />
    </SvgIcon>
  );
};

const RightChevronIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <RightChevronIconDefaultSVG />
    </SvgIcon>
  );
};

const LeftChevronIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <LeftChevronIconDefaultSVG />
    </SvgIcon>
  );
};

const NotificationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Notification />
    </SvgIcon>
  );
};

const UpArrowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UpArrow />
    </SvgIcon>
  );
};

const DownArrowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DownArrow />
    </SvgIcon>
  );
};

const DownArrowFilledIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DownArrowFilled />
    </SvgIcon>
  );
};

const UpArrowFilledIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UpArrowFilled />
    </SvgIcon>
  );
};

const ConfigurationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Configuration />
    </SvgIcon>
  );
};

const SettingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Setting />
    </SvgIcon>
  );
};

const AddTemplateIcon = (props) => {
  return <AddTemplateSvg {...props} />;
};

const PlusIcon = (props) => {
  return <PlusIconSvg {...props} />;
};

const MinusIcon = (props) => {
  return <MinusIconSvg {...props} />;
};

const LinkIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <LinkIconSvg {...props} />
    </SvgIcon>
  );
};

const CheckCircleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CheckCircleSvg {...props} />
    </SvgIcon>
  );
};

const DlrLookupIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DlrLookupSvg {...props} />
    </SvgIcon>
  );
};

const ItemizationReportIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ItemizationReportSVG {...props} />
    </SvgIcon>
  );
};

const ItemizationReportDownloadIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ItemizationReportDownloadSVG {...props} />
    </SvgIcon>
  );
};

const ReportsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ReportsSVG {...props} />
    </SvgIcon>
  );
};

const RakutenIcon = (props) => {
  return <RAKUTEN_LOGO />;
};

const DataNotAvailableIcon = (props) => {
  return <DataNotAvailable />;
};

const TableOptionsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TableOptionsSvg />
    </SvgIcon>
  );
};

const CsvRedIcon = () => <CsvRedSvg />;

const WarningOutlinedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <WarningOutlinedSvg />
    </SvgIcon>
  );
};

const LogoutIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Logout />
    </SvgIcon>
  );
};

const LogoutImageModal = (props) => {
  return (
    <SvgIcon {...props}>
      <LogoutImage />
    </SvgIcon>
  );
};

const ConfirmIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ConfirmIconImage />
    </SvgIcon>
  );
};

const DeleteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DeleteImage />
    </SvgIcon>
  );
};

const NotFoundImageIcon = (props) => {
  return <NotFoundImage {...props} />;
};

const ChangeTemplateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ChangeTemplate />
    </SvgIcon>
  );
};

const NewVersionIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <NewVersion />
    </SvgIcon>
  );
};

const TokenExpiredIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TokenExpired />
    </SvgIcon>
  );
};

const SearchNotFoundIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SearchResultNotFound />
    </SvgIcon>
  );
};

const ArrowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ArrowPointingLeft />
    </SvgIcon>
  );
};

const UserDeleteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserDeleteSVG />
    </SvgIcon>
  );
};

const UserCheckIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <UserCheckSVG />
    </SvgIcon>
  );
};

const TerminateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TerminateSVG />
    </SvgIcon>
  );
};

const TerminateLargeIcon = (props) => {
  return <TerminateLargeSVG {...props} />;
};

const CloseLargeIcon = (props) => {
  return  <CloseModalSVG {...props}/>
};

const TickCircleIcon = (props) => {
  return <TickCircleSVG {...props} />;
};

const CrossCircleIcon = (props) => {
  return <CrossCircleSVG {...props} />;
};

const SenderIdManagementIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SenderIdManagementIconSVG />
    </SvgIcon>
  );
};

const ServiceManagementIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ServiceManagementIconSVG />
    </SvgIcon>
  );
};

const TransactionReportIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <TransactionReportSMSIcon />
    </SvgIcon>
  );
};

const MOTransactionReportIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MOTransactionReportSMSIcon />
    </SvgIcon>
  );
};

const SupportIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SupportIconSVG />
    </SvgIcon>
  );
};

const ManagementIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ManagementIconSVG />
    </SvgIcon>
  );
};

const DistributionIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DistributionIconSVG />
    </SvgIcon>
  );
};

const TimeIcon = (props) => {
  return <TimeIconSVG {...props} />;
};

const TableIcon = (props) => {
  return <TableIconSvg {...props} />;
};
const ContactUsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ContactUsIconSVG />
    </SvgIcon>
  );
};

const DeLinkIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DeLinkSVG />
    </SvgIcon>
  );
};
const EditTemplateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <EditTemplateIconSVG />
    </SvgIcon>
  );
};
const SaveTemplateIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SaveTemplateIconSVG />
    </SvgIcon>
  );
};
const NoTemplateFoundIcon = (props) => {
  return <NoTemplateFoundSVG {...props} />;
};

const SmsServiceIcon = (props) => {
  return <SmsServiceIconSVG />;
};

const EnterpriseListIcon = (props) => {
  return <EnterpriseListIconSVG />;
};

const PendingRequestBlackIcon = (props) => {
  return <PendingRequestIconSVG />;
};

const SenderIdIconSVGIcon = (props) => {
  return <SenderIdIconSVG />;
};

const AdminUserSVGIcon = (props) => {
  return <AdminUserIconSVG />;
};

const AuditLogsSVGIcon = (props) => {
  return <AuditLogsIconSVG />;
};

const CampaignTransationSVGIcon = (props) => {
  return <CampaignTransationIconSVG />;
};

const EnterpriseUserSVGIcon = (props) => {
  return <EnterpriseUserIconSVG />;
};

const ItemizationReportsSVGIcon = (props) => {
  return <ItemizationReportsIconSVG />;
};

const ResellersSVGIcon = (props) => {
  return <ResellersIconSVG />;
};

const HomeSVGIcon = (props) => {
  return <HomeIconSVG />;
};

const GlobalRoutingRulesIcon = (props) => {
  return <GlobalRoutingRulesSvg />;
};

const ConfirmApiHomeIcon = (props) => {
  return <ConfirmApiHomeIconSVG />;
};

const CancelModalImage = (props) => {
  return (
    <SvgIcon {...props}>
      <CancellationModalSVG />
    </SvgIcon>
  );
};

const OptOutMobileImage = (props) => {
  return (
    <SvgIcon {...props}>
      <Infographic />
    </SvgIcon>
  );
};

const InProgressImage = (props) => {
  return (
    <SvgIcon {...props}>
      <InProgress />
    </SvgIcon>
  );
}; 

const DownloadPageIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <Download />
    </SvgIcon>
  );
};

const ExecutionConfirmationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ExecutionConfirmation />
    </SvgIcon>
  );
}; 

const InfographicsConfirmationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <InfographicsConfirmation />
    </SvgIcon>
  );
}; 

const ExecuteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <ExecuteIconSVG />
    </SvgIcon>
  );
};

const OnboardingIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <OnboardingIconSVG />
    </SvgIcon>
  );
}; 

const MessageApiIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MessageApiIconSVG />
    </SvgIcon>
  );
};

const MessageConfirmationIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MessageConfirmationIconSVG />
    </SvgIcon>
  );
};

const MessagingToolIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <MessagingToolIconSVG />
    </SvgIcon>
  );
};

const PhoneIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <PhoneOutlineIconSVG />
    </SvgIcon>
  );
};

const DragDropIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DragDropIconSVG />
    </SvgIcon>
  );
};

const CheckBoxDisableIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <CheckBoxDisable />
    </SvgIcon>
  );
}; 

const SaveModalIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <SaveModalIconSVG />
    </SvgIcon>
  );
};

export {
  AuditLogsIcon,
  EyeIcon,
  EventInfoIcon,
  AlertIcon,
  EyeBanIcon,
  RightChevronIcon,
  LeftChevronIcon,
  GreenCheckIcon,
  ShownModalDownIcon,
  HideModalUpIcon,
  SystemAudienceMessageIcon,
  UnCheckBoxIcon,
  CheckBoxIcon,
  MenuDefaultIcon,
  CrossLimitIcon,
  PendingRequestIcon,
  CrossShowIcon,
  ResetIcon,
  ResetModalIcon,
  RightArrowGreyIcon,
  DownloadIcon,
  PrintIcon,
  SearchIcon,
  ViewColumnIcon,
  FilterIcon,
  UploadIcon,
  MenuIcon,
  WorldIcon,
  AccountIcon,
  BuildingIcon,
  BuildingOutlineIcon,
  CurrencyIcon,
  UserIcon,
  VoiceIcon,
  CopyFieldIcon,
  SurveyIcon,
  ChatIcon,
  HelpIcon,
  FolderIcon,
  MyPageIcon,
  RMI_LOGO,
  RakutenSymphonyLogo,
  CreditCardIcon,
  InfoIcon,
  InfoOutlineIcon,
  TimeIcon,
  ShopIcon,
  PriceYenIcon,
  SecurityIcon,
  PDFIcon,
  ListIcon,
  DashboardIcon,
  EnterpriseIcon,
  EnterpriseConfigIcon,
  AnalyticsIcon,
  UserManagementIcon,
  CsvDownloadButton,
  GreyCsvDownloadButton,
  AdminUserIcon,
  InvoicesIcon,
  HistoricInvoicesIcon,
  SuccessIcon,
  CostIcon,
  QualityIcon,
  DLRIcon,
  SendSMSIcon,
  SmsGuideIcon,
  SendDeliveryIcon,
  OutboundCostIcon,
  OutboundPriceIcon,
  ResellerIcon,
  UserGroupIcon,
  UserGearIcon,
  AddEnterpriseIcon,
  EnterpriseFilterIcon,
  ColumnsIcon,
  SuspendRowIcon,
  DeleteRowIcon,
  EditRowIcon,
  DotsIcon,
  CalendarIcon,
  ColumnUnfrozenIcon,
  CloseIcon,
  StatusCloseIcon,
  CloseModalImage,
  StatusPendingIcon,
  StatusRetiredIcon,
  MarkAsRead,
  CheckIcon,
  TotalSuccessIcon,
  TotalVolumeIcon,
  DownloadOutlineIcon,
  ListOutlineIcon,
  UploadCsvIcon,
  PDFOutlineIcon,
  TotalCostIcon,
  TotalMarginIcon,
  TotalRevenueIcon,
  ExpandIcon,
  CollapseIcon,
  CampaignIcon,
  InboxMessageDefaultIcon,
  ErrorTriangleOutlineIcon,
  GeneralIcon,
  RefreshIcon,
  ReloadIcon,
  NotificationIcon,
  UpArrowIcon,
  DownArrowIcon,
  DownArrowFilledIcon,
  UpArrowFilledIcon,
  ConfigurationIcon,
  SettingIcon,
  TickIcon,
  AddTemplateIcon,
  PlusIcon,
  MinusIcon,
  LinkIcon,
  CheckCircleIcon,
  CSVIcon,
  DlrLookupIcon,
  FaqIcon,
  InsightIcon,
  OutlineIcon,
  RakutenIcon,
  UserImageIcon,
  InvitationIcon,
  DataNotAvailableIcon,
  TableOptionsIcon,
  CsvRedIcon,
  WarningOutlinedIcon,
  DummyIcon,
  LogoutIcon,
  LogoutImageModal,
  ConfirmIcon,
  DeleteIcon,
  NotFoundImageIcon,
  NewVersionIcon,
  TokenExpiredIcon,
  ChangeTemplateIcon,
  SearchNotFoundIcon,
  ArrowIcon,
  UserDeleteIcon,
  UserCheckIcon,
  TerminateIcon,
  TerminateLargeIcon,
  TickCircleIcon,
  CrossCircleIcon,
  PauseModalImage,
  ResumeModalImage,
  ResumeIcon,
  PauseIcon,
  CrownIcon,
  TableIcon,
  SenderIdManagementIcon,
  ServiceManagementIcon,
  UserTagIcon,
  ResellerTagIcon,
  AdminTagIcon,
  ItemizationReportIcon,
  ItemizationReportDownloadIcon,
  TransactionReportIcon,
  MOTransactionReportIcon,
  SupportIcon,
  ManagementIcon,
  ReportsIcon,
  DistributionIcon,
  ContactUsIcon,
  DeLinkIcon,
  EditTemplateIcon,
  SaveTemplateIcon,
  NoTemplateFoundIcon,
  ConfirmAPIIcon,
  ConfirmAPIDashboardIcon,
  DownloadInfoIcon,
  SmsServiceIcon,
  EnterpriseListIcon,
  PendingRequestBlackIcon,
  SenderIdIconSVGIcon,
  AdminUserSVGIcon,
  SuperAdminTagIcon,
  AuditLogsSVGIcon,
  CampaignTransationSVGIcon,
  EnterpriseUserSVGIcon,
  ItemizationReportsSVGIcon,
  ResellersSVGIcon,
  HomeSVGIcon,
  GlobalRoutingRulesIcon,
  ConfirmApiHomeIcon,
  ConfirmAPITransactionIcon,
  CancelModalImage,
  DoubleCheckIcon,
  CsvViewIcon,
  SpamControlIcon,
  OptOutMobileImage,
  AdminUsersTagIcon,
  ResellerUsersTagIcon,
  InProgressImage,
  DownloadPageIcon,
  MailIcon,
  ExecutionConfirmationIcon,
  InfographicsConfirmationIcon,
  ExecuteIcon,
  OnboardingIcon,
  MessageApiIcon,
  CloseLargeIcon,
  MessageConfirmationIcon,
  MessagingToolIcon,
  PhoneIcon,
  DragDropIcon,
  CheckBoxDisableIcon,
  SaveModalIcon
};
